module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page case-study lebenor",
    class: {
      init: _vm.isInit
    }
  }, [_c('div', {
    staticClass: "landing"
  }), _vm._v(" "), _c('div', {
    staticClass: "container-fluid"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "row center-xs content"
  }, [_c('div', {
    staticClass: "col-md-9 col-xs-12"
  }, [_c('router-link', {
    staticClass: "more",
    attrs: {
      "to": "/clients"
    }
  }, [_c('span', [_vm._v("More Case Studies →")])])], 1)]), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "row center-xs contact-btn"
  }, [_c('div', {
    staticClass: "col-md-9 col-xs-12 text-center"
  }, [_c('router-link', {
    staticClass: "next",
    attrs: {
      "to": "/contact"
    }
  }, [_c('span', [_vm._v("Connect to Create")])]), _vm._v(" "), _c('span', {
    staticClass: "line"
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "scroll-btn"
  }, [_c('svg', {
    staticStyle: {
      "enable-background": "new 0 0 477.175 477.175"
    },
    attrs: {
      "version": "1.1",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      "x": "0px",
      "y": "0px",
      "viewBox": "0 0 477.175 477.175",
      "xml:space": "preserve"
    }
  }, [_c('g', [_c('path', {
    attrs: {
      "d": "M360.731,229.075l-225.1-225.1c-5.3-5.3-13.8-5.3-19.1,0s-5.3,13.8,0,19.1l215.5,215.5l-215.5,215.5c-5.3,5.3-5.3,13.8,0,19.1c2.6,2.6,6.1,4,9.5,4c3.4,0,6.9-1.3,9.5-4l225.1-225.1C365.931,242.875,365.931,234.275,360.731,229.075z"
    }
  })])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row center-xs content"
  }, [_c('div', {
    staticClass: "col-md-9 col-xs-12"
  }, [_c('img', {
    staticClass: "text-img",
    attrs: {
      "src": require("../img/lebenor-text-1.png")
    }
  }), _vm._v(" "), _c('p', [_vm._v("Lebenor is a home-automation and IoT startup that is the product of two extremely skilled product development professionals. The organisations sole drive is to make Indian homes a space of interaction with technology to make lives easier & better. The brand offers a range of products from automated lighting to HVAC controls at the tap of a button. They pride themselves in having the ability to introduce international standards of automation at affordable rates.")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row center-xs content"
  }, [_c('div', {
    staticClass: "col-md-10 col-xs-12 cross"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6 col-xs-12"
  }, [_c('div', [_c('img', {
    staticClass: "text-img left",
    attrs: {
      "src": require("../img/lebenor-text-2.png")
    }
  }), _vm._v(" "), _c('p', [_vm._v("What can be done when a company with no name comes knocking on your doors? Well..we were put in a spot that really got us excited - We had to think not just out of the box, had to ponder about things around the box itself! That’s exactly what the now named ‘Lebenor’ brought to us. We were asked to conjure up a name, design a logo and website that defines their vision and value-add without giving a perception of the startup being in an upstarted space. We were given strict instructions to have no restrictions! That made things easy, atleast initially!")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 col-xs-12"
  }, [_c('img', {
    staticClass: "wide-img",
    attrs: {
      "src": require("../img/lebenor-image-1.png")
    }
  })])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row center-xs content"
  }, [_c('div', {
    staticClass: "col-md-9 col-xs-12"
  }, [_c('img', {
    staticClass: "text-img",
    attrs: {
      "src": require("../img/lebenor-text-3.png")
    }
  }), _vm._v(" "), _c('p', [_vm._v("We first put ourselves in the shoes our direct customers. This brought us to conduct a deep rooted research exercise that scanned every nook and corner for a whole plethora of questions we were asking ourselves. This research extended to interviewing the direct target group of users / integrators / architects and anyone even closely related to home design & decor. Reading between the lines brought us to the conclusion that every aspiring Indian wanted a home that is technologically advanced, only if it has the ‘Made Internationally’ tag to it. This insight led us to create a brand name that was memorable, simple & of course ‘Global’ in appeal. Thus was born ‘Lebenor’ - Leiben is Life + Lore is Knowledge - a German hybrid of sorts that is a symbol of technological evolution. The brand logo and website were a natural extension that proved to a great fit with their branding idea of “Evolving Dimensions”.")]), _vm._v(" "), _c('div', {
    staticClass: "large-img"
  }, [_c('img', {
    attrs: {
      "src": require("../img/lebenor-image-2.png")
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "large-img"
  }, [_c('img', {
    attrs: {
      "src": require("../img/lebenor-image-3.png")
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "large-img"
  }, [_c('img', {
    attrs: {
      "src": require("../img/lebenor-image-4.png")
    }
  })])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row center-xs last"
  }, [_c('div', {
    staticClass: "col-md-9 col-xs-12"
  }, [_c('p', [_vm._v("If you’re looking for fresh and impactful solutions,"), _c('br'), _vm._v("we’re your guys.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7b8196b7"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/LebenorCaseStudy.vue
// module id = 163
// module chunks = 0